import { AppUpdateService } from '$core/services/app-update.service';
import { BrowserDetectService } from '$core/services/browser-detect.service';
import { LanguageService } from '$core/services/language.service';
import { RouterScrollService } from '$core/services/router-scroll.service';
import { environment } from '$env/environment';
import {
  AfterViewInit,
  Component,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NavigationError, Router } from '@angular/router';
import { isChunkLoadError } from '$core/helpers/sentry-filters';
import { CookiesHandlingService } from '$modules/pages/cookies-settings/services/cookies-handling.service';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';
import { NotificationsDataService } from '$modules/personal/notifications/notifications-data.service';
import { NotificationsHttpService } from '$modules/personal/notifications/notifications-http.service';
import { EMPTY } from 'rxjs';
import { auditTime, catchError, switchMap } from 'rxjs/operators';
// import * as Sentry from '@sentry/browser';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  public showTranslateDebug = environment.showTranslateDebug;

  constructor(
    protected routerScrollService: RouterScrollService,
    protected appUpdateService: AppUpdateService,
    protected browserDetectService: BrowserDetectService,
    private cookiesService: CookiesHandlingService,
    private router: Router,
    private zone: NgZone,
    private languageService: LanguageService,
    private meta: Meta,
    private notificationsDataService: NotificationsDataService,
    private notificationsHttpService: NotificationsHttpService
  ) {}

  public ngOnInit() {
    // if (
    //   environment.sentry &&
    //   !window['webpackHotUpdate'] &&
    //   !navigator.webdriver
    // ) {
    //   Sentry.init({
    //     dsn:
    //       'https://946fe29432854c2faa2ae4e866c2476d@mysentry.naveksoft.com/17',
    //     environment: environment.name,
    //     release: 'web',
    //     ignoreErrors: [
    //       // Applivation specific
    //       'Loading chunk',
    //       'Unexpected token <',
    //       'Non-Error exception captured',
    //       'Expression has changed after it was checked',
    //       // Random plugins/extensions
    //       'top.GLOBALS',
    //       // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    //       'originalCreateNotification',
    //       'canvas.contentDocument',
    //       'MyApp_RemoveAllHighlights',
    //       'http://tt.epicplay.com',
    //       "Can't find variable: ZiteReader",
    //       'jigsaw is not defined',
    //       'ComboSearch is not defined',
    //       'http://loading.retry.widdit.com/',
    //       'atomicFindClose',
    //       // Facebook borked
    //       'fb_xd_fragment',
    //       // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    //       // reduce this. (thanks @acdha)
    //       // See http://stackoverflow.com/questions/4113268
    //       'bmi_SafeAddOnload',
    //       'EBCallBackMessageReceived',
    //       // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    //       'conduitPage',
    //     ],
    //     blacklistUrls: [
    //       // Facebook flakiness
    //       /graph\.facebook\.com/i,
    //       // Facebook blocked
    //       /connect\.facebook\.net\/en_US\/all\.js/i,
    //       // Woopra flakiness
    //       /eatdifferent\.com\.woopra-ns\.com/i,
    //       /static\.woopra\.com\/js\/woopra\.js/i,
    //       // Chrome extensions
    //       /extensions\//i,
    //       /^chrome:\/\//i,
    //       // Other plugins
    //       /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    //       /webappstoolbarba\.texthelp\.com\//i,
    //       /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    //     ],
    //     integrations(integrations) {
    //       return integrations.filter(i => i.name !== 'TryCatch');
    //     },
    //     debug: false,
    //   });
    // }

    // IntersectionObserver polyfill settings
    if (IntersectionObserver) {
      (<any>IntersectionObserver).prototype.USE_MUTATION_OBSERVER = false; // Prevents perfomance issue
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        // Тот же признак, что и в ErrorsHandlerService: такие ошибки не уходят
        // в Sentry, потому что здесь страница перезагружается.
        if (isChunkLoadError(event.error)) {
          location.assign(event.url);
        }
      }
    });

    this.observeNotificationsCounterRefresh();
  }

  public ngAfterViewInit() {
    this.cookiesService.selectedCookies$
      .pipe(untilDestroyed(this))
      .subscribe((settings) => {
        // Был добавлен false, т.к с 1 июля 2023 сервис перестал обрабатывать данные
        if (
          environment.gtag &&
          !window['webpackHotUpdate'] &&
          !navigator.webdriver &&
          settings.googleAnalytics
        ) {
          this.appendGoogleAnalytics();
        }
        // Был добавлен false, т.к с 1 июля 2023 сервис перестал обрабатывать данные
        if (
          environment.gtm &&
          !window['webpackHotUpdate'] &&
          !navigator.webdriver &&
          settings.googleTagManager
        ) {
          this.appendGoogleTagManager();
        }

        if (
          environment.metrika &&
          !window['webpackHotUpdate'] &&
          !navigator.webdriver &&
          settings.yandexMetrica
        ) {
          this.appendYandexMetrika();
        }

        if (settings.bitrix) {
          this.appendBitrixChat();
        }
      });

    this.cookiesService.checkCookiesOnInit();

    document
      .getElementsByTagName('html')[0]
      .setAttribute('lang', this.languageService.currentLang);

    this.languageService.currentLang$
      .pipe(untilDestroyed(this))
      .subscribe((lang) => document.documentElement.setAttribute('lang', lang));

    if (!environment.indexing) {
      this.meta.addTag({ name: 'robots', content: 'noindex' });
    }
  }

  private appendBitrixChat(): void {
    if (
      environment.navekConnect &&
      !window['webpackHotUpdate'] &&
      !navigator.webdriver
    ) {
      this.injectWidget(
        'https://cdn.belpost.by/navekconnect/js/navekconnect.js'
      );
    } else if (!environment.navekConnect) {
      this.injectWidget(
        'https://post24.belpost.by/upload/crm/site_button/loader_1_gs0tcx.js'
      );
    }
  }

  private injectWidget(url: string) {
    this.zone.runOutsideAngular(() => {
      (function (d, u) {
        const s = d.createElement('script');
        s.async = true;
        s.src = u + '?' + Math.floor(Date.now() / 60000);
        const h = d.getElementsByTagName('script')[0];
        h.parentNode.insertBefore(s, h);
      })(document, url);
    });
  }

  private appendGoogleAnalytics() {
    if (!environment.gtag) {
      return;
    }

    const script = document.createElement('script');
    const id = (<any>environment.gtag).site;

    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
    script.async = true;
    document.head.appendChild(script);

    const script2 = document.createElement('script');
    script2.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${id}', {
        'linker': {
          'domains': ['blog.belpost.by']
        }
      });`;
    document.head.appendChild(script2);
  }

  private appendGoogleTagManager() {
    if (!environment.gtm) {
      return;
    }

    const id = (<any>environment.gtm).site;
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
      {'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${id}');`;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
      height="0"width="0"style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
  }

  private appendYandexMetrika() {
    if (!environment.metrika) {
      return;
    }

    const id = (<any>environment.metrika).site;

    const script = document.createElement('script');
    // tslint:disable: max-line-length
    script.innerHTML = `
      (function(m,e,t,r,i,k,a){
          m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
      })(window, document,'script','https://mc.yandex.ru/metrika/tag.js', 'ym');
      ym(${id}, 'init', {webvisor:true, clickmap:true, accurateTrackBounce:true, trackLinks:true});
    `;
    // tslint:enable: max-line-length
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${id}" style="position:absolute; left:-9999px;" alt="" /></div>`;
    document.body.appendChild(noscript);
  }

  private observeNotificationsCounterRefresh(): void {
    this.notificationsDataService.refresh$
      .pipe(
        auditTime(100),
        // catchError внутри switchMap: ошибка одного запроса (401 при истёкшей
        // сессии, сеть) не должна завершать поток — иначе счётчик больше
        // не обновляется до перезагрузки страницы.
        switchMap(() =>
          this.notificationsHttpService
            .getUnreadNotificationsCount()
            .pipe(catchError(() => EMPTY))
        ),
        untilDestroyed(this)
      )
      .subscribe((res) => {
        this.notificationsDataService.setCounter(res.count);
      });
  }

  public ngOnDestroy() {}
}
